import React from 'react';
import { Menu, Card, TreeSelect } from 'antd';
import app, { api, use } from 'xadmin';
import { HasPermission } from 'xadmin-auth';
import { Icon, C } from 'xadmin-ui';
import { Model } from 'xadmin-model';
import _ from 'lodash'

const { TreeNode } = TreeSelect
let defaultData = [
  {
    title: '发送指令',
    value: '发送指令'
  },
  {
    title: '用户登录',
    value: '用户登录'
  },
  {
    title: '密码修改',
    value: '密码修改'
  },
  {
    title: '巡检记录',
    value: '巡检记录'
  },
  {
    title: '操作记录',
    value: '操作记录'
  },
  {
    title: '模型',
    value: '模型',
    children: [
      {
        title: '模型增加',
        value: '模型增加'
      },
      {
        title: '模型修改',
        value: '模型修改'
      },
      {
        title: '模型删除',
        value: '模型删除'
      }
    ]
  },
  {
    title: '资产',
    value: '资产',
    children: [
      {
        title: '资产增加',
        value: '资产增加'
      },
      {
        title: '资产修改',
        value: '资产修改'
      },
      {
        title: '资产删除',
        value: '资产删除'
      }
    ]
  },
  {
    title: '工作表',
    value: '工作表',
    children: [
      {
        title: '工作表增加',
        value: '工作表增加'
      },
      {
        title: '工作表修改',
        value: '工作表修改'
      },
      {
        title: '工作表删除',
        value: '工作表删除'
      }
    ]
  },
  {
    title: '工作表记录',
    value: '工作表记录',
    children: [
      {
        title: '工作表记录增加',
        value: '工作表记录增加'
      },
      {
        title: '工作表记录修改',
        value: '工作表记录修改'
      },
      {
        title: '工作表记录删除',
        value: '工作表记录删除'
      }
    ]
  },
  {
    title: '数据同步',
    value: '数据同步',
    children: [
      {
        title: '数据同步增加',
        value: '数据同步增加'
      },
      {
        title: '数据同步修改',
        value: '数据同步修改'
      },
      {
        title: '数据同步删除',
        value: '数据同步删除'
      }
    ]
  },
  {
    title: '流程',
    value: '流程',
    children: [
      {
        title: '流程增加',
        value: '流程增加'
      },
      {
        title: '流程修改',
        value: '流程修改'
      },
      {
        title: '流程删除',
        value: '流程删除'
      }
    ]
  },
  {
    title: '报警',
    value: '报警',
    children: [
      {
        title: '报警处理',
        value: '报警处理'
      },
      {
        title: '报警确认',
        value: '报警确认'
      },
      {
        title: '报警备注',
        value: '报警备注'
      },
      {
        title: '添加报警清除配置',
        value: '添加报警清除配置',
      },
      {
        title: '更改报警清除配置',
        value: '更改报警清除配置',
      },
      {
        title: '删除报警清除配置',
        value: '删除报警清除配置',
      },
      {
        title: '一次性报警清除',
        value: '一次性报警清除',
      },
      {
        title: '定时报警清除',
        value: '定时报警清除',
      },
      {
        title: '添加报警归档配置',
        value: '添加报警归档配置',
      },
      {
        title: '更改报警归档配置',
        value: '更改报警归档配置',
      },
      {
        title: '删除报警归档配置',
        value: '删除报警归档配置',
      },
      {
        title: '定时报警归档',
        value: '定时报警归档',
      },
      {
        title: '一次性报警归档',
        value: '一次性报警归档',
      },
    ]
  },
  {
    title: '画面',
    value: '画面',
    children: [
      {
        title: '新增普通画面',
        value: '新增普通画面'
      },
      {
        title: '新增资产画面',
        value: '新增资产画面'
      },
      {
        title: '新增模型画面',
        value: '新增模型画面'
      },
      {
        title: '新增工作表画面',
        value: '新增工作表画面'
      },
      {
        title: '编辑普通画面',
        value: '编辑普通画面'
      },
      {
        title: '编辑资产画面',
        value: '编辑资产画面'
      },
      {
        title: '编辑模型画面',
        value: '编辑模型画面'
      },
      {
        title: '编辑工作表画面',
        value: '编辑工作表画面'
      },
      {
        title: '删除普通画面',
        value: '删除普通画面'
      },
      {
        title: '删除资产画面',
        value: '删除资产画面'
      },
      {
        title: '删除模型画面',
        value: '删除模型画面'
      },
      {
        title: '删除工作表画面',
        value: '删除工作表画面'
      },
      {
        title: '分享画面',
        value: '分享画面'
      }
    ]
  },
  {
    title: '事件',
    value: '事件',
    children: [
      {
        title: '事件增加',
        value: '事件增加'
      },
      {
        title: '事件修改',
        value: '事件修改'
      },
      {
        title: '事件删除',
        value: '事件删除'
      }
    ]
  },
  {
    title: '事件动作',
    value: '事件动作',
    children: [
      {
        title: '事件动作增加',
        value: '事件handle增加'
      },
      {
        title: '事件动作修改',
        value: '事件handle修改'
      },
      {
        title: '事件动作删除',
        value: '事件handle删除'
      }
    ]
  },
  {
    title: '媒体库',
    value: '媒体库',
    children: [
      {
        title: '媒体库上传文件',
        value: '媒体库上传文件'
      },
      {
        title: '媒体库解压文件',
        value: '媒体库解压文件'
      },
      {
        title: '媒体库新建目录',
        value: '媒体库新建目录'
      },
      {
        title: '媒体库移动文件',
        value: '媒体库移动文件'
      },
      {
        title: '媒体库删除文件',
        value: '媒体库删除文件'
      },
      {
        title: '媒体库恢复文件',
        value: '媒体库恢复文件'
      },
      {
        title: '媒体库重命名文件',
        value: '媒体库重命名文件'
      }
    ]
  },
  {
    title: '备份数据',
    value: '备份数据',
  },
  {
    title: '还原数据',
    value: '还原数据',
  },
  {
    title: '操作日志',
    value: '操作日志',
    children: [
      {
        title: '添加日志清除配置',
        value: '添加日志清除配置',
      },
      {
        title: '更改日志清除配置',
        value: '更改日志清除配置',
      },
      {
        title: '删除日志清除配置',
        value: '删除日志清除配置',
      },
      {
        title: '一次性日志清除',
        value: '一次性日志清除',
      },
      {
        title: '定时日志清除',
        value: '定时日志清除',
      },
      {
        title: '添加日志归档配置',
        value: '添加日志归档配置',
      },
      {
        title: '更改日志归档配置',
        value: '更改日志归档配置',
      },
      {
        title: '删除日志归档配置',
        value: '删除日志归档配置',
      },
      {
        title: '定时日志归档',
        value: '定时日志归档',
      },
      {
        title: '一次性日志归档',
        value: '一次性日志归档',
      },
    ]
  }
]

const LogType = props => {
  const { input: { value, onChange } } = props
  const [data, setData] = React.useState('')
  const { settings } = use('settings')
  const logSaveRule = settings?.log?.logSaveRule || settings?.logSaveRule
  const filteredObj = {};

  for (const key in logSaveRule) {
    if (key.includes('_')) {
      filteredObj[key] = logSaveRule[key];
    }
  }

  React.useEffect(() => {
    const logtrue = {};
    for (const key in filteredObj) {
      if (filteredObj[key] === true) {
        logtrue[key] = true;
      }
    }
    function groupBy(data, separator = '_') {
      const result = {};
      for (const key in data) {
        const [parent, child] = key.split(separator);
        if (!(parent in result)) {
          result[parent] = { children: [] };
        }
        const value = key.substring(key.indexOf(separator) + 1);
        result[parent].children.push({ title: child, value });
      }
      return result;
    }

    const groupedData = groupBy(logtrue);
    const result = Object.entries(groupedData).map(([title, { children }]) => ({
      title,
      value: title,
      children
    }));

    api({ name: 'core/log/type' })
      .fetch('', {})
      .then(({ json }) => {
        let logJson = json?.data
        const nochildren = logJson.reduce((arr, item) => {
          if (!item.children) {
            arr.push({ title: item.title, value: item.value });
          }
          return arr;
        }, []);
        const filteredData = nochildren?.filter(item => logSaveRule[item?.value] === true);
        const combinedData = filteredData.concat(result);
        logSaveRule?.checked && !_.isEmpty(result) ? setData(combinedData) : setData(logJson)
      })
  }, [])


  const handleChange = values => {
    let v = {}
    if (values) {
      if (values.length > 1) {
        v = { $in: values }
      } else if (values.length > 0) {
        v = values[0]
      }
    }
    console.log(v)
    onChange(v)
  }

  let seleted = []
  // 初始化value
  if (value && value != '') {
    if (_.isString(value)) seleted = [value]
    if (_.isObject(value)) seleted = value.$in
    if (_.isArray(value)) seleted = value
  }

  const renderData = data => {
    return data && data.length && data.map(item => {
      if (item.children && item.children.length) {
        return (
          <TreeNode
            key={item.value}
            title={item.title}
            value={item.value}
            disabled={true}
          >
            {renderData(item.children)}
          </TreeNode>
        );
      }
      return (
        <TreeNode
          key={item.value}
          value={item.value}
          title={item.title}
        />
      );
    })
  }

  return (
    <TreeSelect
      showSearch
      placeholder="搜索操作类型"
      style={{ width: '100%', minWidth: 175 }}
      value={seleted}
      dropdownStyle={{ maxHeight: 400, overflow: 'auto', width: '100%' }}
      allowClear
      multiple
      onChange={handleChange}
    >
      {renderData(data)}
    </TreeSelect>
  )
}

export default LogType
